<template>
  <div class="chart-container conversion-rate-chart">
    <div class="chart-header">
      <h4 class="chart-title">Tasa de Conversión</h4>
      <div v-if="viewOptions.length > 1" class="chart-controls">
        <label class="sr-only" for="conversion-view-select">Modo de visualización</label>
        <select
          id="conversion-view-select"
          v-model="localViewMode"
          class="view-select"
        >
          <option
            v-for="option in viewOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>

    <component
      v-if="hasData"
      :is="currentChartComponent"
      :chart-data="chartData"
      :options="options"
      :height="350"
    />
    <p v-else class="no-data-message">No hay datos de conversión disponibles.</p>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.js';
import BarChart from '@/components/charts/BarChart.js';

export default {
  name: 'ConversionRateChart',
  components: {
    LineChart,
    BarChart,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: String,
      required: true,
    },
    viewOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localViewMode: this.viewMode,
    };
  },
  watch: {
    viewMode(newMode) {
      if (newMode !== this.localViewMode) {
        this.localViewMode = newMode;
      }
    },
    localViewMode(newMode) {
      if (newMode !== this.viewMode) {
        this.$emit('update:viewMode', newMode);
      }
    },
  },
  computed: {
    currentChartComponent() {
      return this.localViewMode === 'monthly' ? BarChart : LineChart;
    },
    hasData() {
      return (
        this.chartData &&
        Array.isArray(this.chartData.datasets) &&
        this.chartData.datasets.some(
          (dataset) => Array.isArray(dataset.data) && dataset.data.length > 0
        )
      );
    },
  },
};
</script>

<style scoped>
.conversion-rate-chart {
  display: flex;
  flex-direction: column;
  min-height: 350px;
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 6px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.chart-title {
  font-size: 1em;
  font-weight: 500;
  color: #666;
}

.chart-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.view-select {
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 0.9em;
  color: #333;
  background-color: #fff;
}

.view-select:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(54, 162, 235, 0.4);
  border-color: #36a2eb;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.no-data-message {
  text-align: center;
  color: #888;
  padding: 40px 10px;
  font-style: italic;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.conversion-rate-chart ::v-deep .chartjs-render-monitor {
  flex-grow: 1;
}
</style>
